/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
export default function validate(values) {
  let errors = {};
  if (!values.disclaimer) {
    errors.disclaimer = 'Disclaimer must be accepted';
  }

  if (!values.email) {
    errors.email = 'Email is required';
  }

  return errors;
}
